import { Accordion, Flex, Text } from '@mantine/core';
import classes from './Location.module.css';
import { PartnerPharmacies } from './PartnerPharmacies';
import { OwnLocations } from './OwnLocations';
import { useWindowSize } from '../../../../../hooks';
import { useTranslation } from 'react-i18next';

export const LocationWrapper = ({ id }: { id: string }) => {
  const isSmallScreen = useWindowSize(600);
  const { t } = useTranslation('landingpage');

  return (
    <Flex
      id={id}
      className={classes.baseSection}
      justify="space-between"
      p="40px 0px 0px 0px"
      direction="column"
    >
      <Text className={classes.title} c="#202020" w="100%">
        {t('Locations.SellingPoints')}
      </Text>
      <Accordion
        multiple
        defaultValue={['own_locations', 'partner_pharmacies']}
        w="100%"
        variant="unstyled"
        styles={{
          chevron: { display: isSmallScreen ? 'block' : 'none' },
          control: { padding: isSmallScreen ? '16px' : '35px 16px' },
          content: { padding: '0px 16px' },
          label: { padding: '0px' },
        }}
        p="0px 20px"
      >
        <Accordion.Item
          key={'own_locations'}
          value={'own_locations'}
          bg="#f1f0e899"
          style={{ borderRadius: '8px' }}
          p="0px"
        >
          <Accordion.Control>
            <Text className={classes.locationSubTitle}>
              {t('Locations.OwnLocations')}
            </Text>
          </Accordion.Control>
          <Accordion.Panel>
            <OwnLocations />
          </Accordion.Panel>
        </Accordion.Item>
        <Accordion.Item key={'partner_pharmacies'} value={'partner_pharmacies'}>
          <Accordion.Control>
            <Text className={classes.locationSubTitle}>
              {t('Locations.PartnerLocations')}
            </Text>
          </Accordion.Control>
          <Accordion.Panel>
            <PartnerPharmacies />
          </Accordion.Panel>
        </Accordion.Item>
      </Accordion>
    </Flex>
  );
};
